import { ReactNode } from 'react';
import { PromptsBoxSimple } from './input-atoms/PromptsBoxSimple';
import { PromptsBoxProps } from './input-atoms/promptsBoxTypes';
import { Box } from '@mui/material';
import { TextFieldWithButton } from './input-atoms/TextFieldWithButton';

interface AiChatInputProps extends Omit<PromptsBoxProps, 'predefinedPrompts'> {
  isLoading: boolean;
  predefinedPrompts?: { [key: string]: string };
  value: string;
  setValue: (value: string) => void;
  inputPlaceholder?: string;
  headerText?: ReactNode;
}

export const AiChatInput = ({
  value,
  setValue,
  predefinedPrompts,
  onConfirm,
  isLoading,
  disabled,
  inputPlaceholder,
  headerText,
}: AiChatInputProps) => {
  return (
    <Box p={1.5}>
      {predefinedPrompts && (
        <PromptsBoxSimple
          predefinedPrompts={predefinedPrompts}
          onConfirm={onConfirm}
          headerText={headerText}
          disabled={disabled}
        />
      )}

      <TextFieldWithButton
        value={value}
        setValue={setValue}
        onConfirm={onConfirm}
        inputPlaceholder={inputPlaceholder ?? 'Ask anything'}
        isLoading={isLoading}
        readonly={disabled}
        data-testid="ai-chat-input"
      />
    </Box>
  );
};
